/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * The header that will be set to a mocked response
 */

// required attributes
const ResponseHeaderR = t.interface({
  name: t.string,

  value: t.string
});

// optional attributes
const ResponseHeaderO = t.partial({});

export const ResponseHeader = t.intersection(
  [ResponseHeaderR, ResponseHeaderO],
  "ResponseHeader"
);

export type ResponseHeader = t.TypeOf<typeof ResponseHeader>;
